import React from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import { getClassNames } from '../../utils';
import withTheme from '../../hocs/withTheme';
import './Navigation.css';
function Link({
    children = null,
    hasChanges = false,
    homeLink = false,
    externalURL = false,
    to = { pathname: '/'},
    ...rest
}) {
    const selectNavigationClassName = getClassNames(
        'Navigation__link',
        { Navigation__link_changed: hasChanges },
        { Navigation__link_home: homeLink },
    );

    return externalURL ?
        (
            <a href={to.pathname} target={rest.target}
               className={selectNavigationClassName}>{children}</a>
        ):(
            <RouterLink
                {...rest}
                activeClassName="Navigation__link-active"
                className={selectNavigationClassName}
            >
                {children}
            </RouterLink>
        );
}


export default withTheme(Link);
